import { CohesionProvider } from "@redventures/cohesion-utils-react";

export const withCohesion = ({ App, components }) => {
  const CohesionProviderHOC = (props) => (
    <CohesionProvider components={components}>
      <App {...props} />
    </CohesionProvider>
  );
  return CohesionProviderHOC;
};
